//export const API_BASE_URL = "https://localhost:44328/rtc2";
export const API_BASE_URL = "https://one.beamstream.eu";

// Change this path if your backend hub endpoint differs.
export const APP_HUB_URL = `${API_BASE_URL}/ViewerHub`;

//export const API_BASE_URL = "https://api.spotlight-manager.de/api/v1";

